//this closure ensures we won't be interfering with other libraries that have defined $
(function ($) {
	'use strict';
    let products = {
    	'AbendAID' : {
	    	id : 'abendAidCard',
	    	className : 'operations',
	    	href : 'jsp/abendaid.jsp',
	    	image : 'img/Abend_AID_nameplate.svg',
	    	description : abendAidDescription,
	    	altText : 'Abend-AID',
    		altName : 'FaultAnalytics',
   	    	altHref : 'https://compuware.com/abend-aid-fault-management/'
	    }, 
	    'AppAudit' : {
	    	id : 'appauditCard',
	    	className : 'cybersecurity',
	    	href : '/appaudit',
	    	image : 'img/App_Audit_nameplate.svg',
	    	description : appauditDescription,
	    	altText : 'Application Audit',
   	    	altHref : 'https://compuware.com/application-audit/'
	    }, 
	    'ISPW iBrowser' : {
	    	id : 'ispwCard',
	    	className : 'build-deploy',
	    	href : '/iBrowser',
	    	image : 'img/ISPW_nameplate.svg',
	    	description : ispwDescription,
	    	altText : 'ISPW',
   	    	altHref : 'https://compuware.com/ispw-source-code-management/'
	    }, 
	    'iStrobe' : {
	    	id : 'istrobeCard',
	    	className : 'operations',
	    	href : '/istrobe',
	    	image : 'img/Strobe_nameplate.svg',
	    	description : iStrobeDescription,
	    	altText : 'Strobe',
   	    	altHref : 'https://compuware.com/strobe-mainframe-performance-monitoring/'
	    }, 
	    'ThruPutManager' : {
	    	id : 'thruputCard',
	    	className : 'operations',
	    	href : '/thruput',
	    	image : 'img/ThruPut_Manager_nameplate.svg',
	    	description : thruputManagerDescription,
	    	altText : 'ThruPut Manager',
   	    	altHref : 'https://compuware.com/thruputmanager-batch-automation/'
	    }, 
	    'topazjava' : {
	    	id : 'topazjavaCard',
	    	className : 'operations',
	    	href : '/topazjava',
	    	image : 'img/Topaz_for_JP_nameplate.svg',
	    	description : cjpDescription,
	    	altText : 'Topaz for Java Performance',
   	    	altHref : 'https://compuware.com/topaz-for-java-performance/'
	    }, 
	    'TotalTest' : {
	    	id : 'totalTestCard',
	    	className : 'development',
	    	href : '/totaltest',
	    	image : 'img/Topaz_for_TT_nameplate.svg',
	    	description : totalTestDescription,
	    	altText : 'Topaz for Total Test',
   	    	altHref : 'https://compuware.com/topaz-for-total-test-automation/'
	    }
	};
    
    let installedProducts = [];
    let nonInstalledProducts = [];
    
    $(document).on('appsListed', function (event, data) {
    	let productCardsTemplate = $('#productCardsTemplate').html().trim();    	
        let applications = data.applications;
        let applicationNames = applications.map(function(application) {
        	return application.app;
        });
        
        Object.keys(products).forEach(function(productName) {
        	let product = products[productName];
        	let altName = !!product.altName ? product.altName : '';
        	
        	if (applicationNames.indexOf(productName) > -1 || (!!product.altName && applicationNames.indexOf(product.altName) > -1)) {
        		installedProducts.push(product);
        	} else {
        		product.href = product.altHref;
        		product.external = true;
        		nonInstalledProducts.push(product);
        	}
        });
        
        $('#installedProducts').append(Mustache.to_html(productCardsTemplate, {products : installedProducts}));
        $('#nonInstalledProducts').append(Mustache.to_html(productCardsTemplate, {products : nonInstalledProducts}));
        
        if (installedProducts.length === 0) {
        	$('.installed-products-label').hide();
        	$('#installedProducts').hide();
        }
        
        if (nonInstalledProducts.length === 0) {
        	$('.non-installed-products-label').hide();
        }
        
        $('.product-card').on('keypress', function (event) {
            if (event.keyCode === 32 || event.keyCode === 13) {
            	$(this).find('.product-contents')[0].click();
            }
        }); 
    });
})(jQuery);